import styled from 'styled-components'

export const tabGrupoRegraStyles = {
  Container: styled.div`
    margin: 16px;
  `
}
